<template>
	<v-select
		:id="id"
		:label="label"
		:loading="loading"
		:disabled="disabled"
		:readonly="readonly"
		:items="items"
		:rules="rules"
		:item-text="itemText"
		:item-value="itemValue"
		:hide-details="hideDetails"
		outlined
		class="mt-3 pt-0"
		:class="customClass"
		v-model="selectinput"
		:placeholder="placeholder"
		:append-outer-icon="appendOuterIcon"
		v-on:click:append-outer="$emit('click:append-outer', true)"
		v-on:change="$emit('change', selectinput)"
	>
		<template v-slot:no-data>
			<v-list-item>
				<v-list-item-title v-html="`No ${placeholder} Found.`"></v-list-item-title>
			</v-list-item>
		</template>
	</v-select>
</template>
<script>
export default {
	name: "select-input",
	model: {
		prop: "value",
		event: "change",
	},
	props: {
		value: {
			type: [Object, Number, String, Array],
			default: null,
		},
		items: {
			type: Array,
			required: true,
			default: () => {
				return [];
			},
		},
		rules: {
			type: [Array, Object],
			default: () => {
				return [];
			},
		},
		customClass: {
			type: String,
			default: "mt-3 pt-0",
		},
		placeholder: {
			type: String,
			default: null,
		},
		appendOuterIcon: {
			type: String,
			default: null,
		},
		id: {
			type: String,
			default: null,
		},
		label: {
			type: String,
			default: null,
		},
		hideDetails: {
			type: Boolean,
			default: false,
		},
		itemText: {
			type: String,
			default: "text",
		},
		itemValue: {
			type: String,
			default: "value",
		},
		loading: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		readonly: {
			type: Boolean,
			default: false,
		},
	},
	watch: {
		value: {
			deep: true,
			immediate: true,
			handler(param) {
				this.selectinput = param;
			},
		},
	},
	data() {
		return {
			selectinput: null,
		};
	},
	mounted() {
		this.selectinput = this.value;
	},
};
</script>
